import { environment } from 'config'

export function getApiURL(path: string) {
  const host = environment.isTest ? 'http://localhost:3000' : ''
  return host + path
}
